module.exports = __webpack_public_path__ + "static/media/newsletter.844aba80.png";